import { Alert, Button, Card, Spin } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import BrandLogo from 'assets/img/workplansiq-logo.svg'
import { takeOidcPostLoginRedirect } from 'services/auth/oidcRedirect'
import { resolvePostLoginDestination } from 'services/auth/postLoginRoute'
import { savePricingIntentFromRedirect } from 'services/auth/onboardingStatus'
import useAuthRepo from 'services/repo/useAuthRepo'
import LocalStorageUtils from 'utils/LocalStorage'
import { applyDemoScenario } from 'services/tenant/demoScenarioService'

export default function OidcCallback() {
    const { exchangeOidcHandoff } = useAuthRepo(false)
    const navigate = useNavigate()
    const hasStarted = useRef(false)
    const [errorMessage, setErrorMessage] = useState("")

    useEffect(() => {
        if (hasStarted.current) return
        hasStarted.current = true

        const params = new URLSearchParams(window.location.hash.substring(1))
        const handoff = params.get('handoff')

        window.history.replaceState({}, document.title, `${window.location.pathname}${window.location.search}`)

        const completeLogin = async () => {
            if (!handoff) {
                setErrorMessage('Google sign-in callback is missing its handoff code.')
                return
            }

            const response = await exchangeOidcHandoff(handoff)
            if (!response || !LocalStorageUtils.jwtToken.get()) {
                setErrorMessage(response?.detail || 'Google sign-in could not be completed. Please try again.')
                return
            }

            try {
                const redirectTo = takeOidcPostLoginRedirect()
                const scenarioId = sessionStorage.getItem('workplansiq.pendingDemoScenario')
                sessionStorage.removeItem('workplansiq.pendingDemoScenario')
                const scenario = scenarioId ? applyDemoScenario(scenarioId) : null
                const user = LocalStorageUtils.userInfo.get() || {}
                const ownerEmail = user.email || user.emailAddress || user.preferred_username || user.username
                savePricingIntentFromRedirect(redirectTo, ownerEmail)
                const destination = await resolvePostLoginDestination({ redirectTo: scenario?.entryPath || redirectTo })
                navigate(destination, { replace: true })
            } catch {
                setErrorMessage('You are signed in, but we could not load your organization access.')
            }
        }

        completeLogin()
    }, [exchangeOidcHandoff, navigate])

    return (
        <div className="login-page oidc-callback-page">
            <Card className="oidc-callback-card">
                <img src={BrandLogo} alt="WorkPlansIQ" />
                {errorMessage ? (
                    <>
                        <Alert type="error" showIcon message="Google sign-in failed" description={errorMessage} />
                        <Button type="primary" block size="large" onClick={() => navigate('/', { replace: true })}>
                            Back to sign in
                        </Button>
                    </>
                ) : (
                    <div className="oidc-callback-loading">
                        <Spin size="large" />
                        <h2>Completing your sign-in</h2>
                        <p>Please wait while we securely connect your WorkPlansIQ account.</p>
                    </div>
                )}
            </Card>
        </div>
    )
}
